import { Link } from "react-router-dom";

const LOGO_URL =
  "https://cdn.gamma.app/bic4dw5emd3666n/6b962ca40c454adca600765544de7365/original/1ev5dw09_IWMC_logo_transparent.png";

/**
 * Brand logo block in the site header — closes the mobile drawer on click.
 */
export default function HeaderLogo({ onClick }) {
  return (
    <Link
      to="/"
      data-testid="logo-link"
      onClick={onClick}
      className="group flex items-center shrink-0"
    >
      <img
        src={LOGO_URL}
        alt="Integrated Wellness Medical Centers — full color logo"
        className="h-10 md:h-12 w-auto object-contain"
      />
    </Link>
  );
}
